import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import ReactMarkdown from 'react-markdown'
import gfm from 'remark-gfm';
import { ReactComponent as HelpIcon } from '../assets/icons/information.svg';

/**
 * Dynamic help page.
 */
export default function LocalHelp({
  markdown,
  iconSize = "1.5em",
  ...props
}) {
  const [ show, setShow ]         = useState(false);

  return (
    <>
      <HelpIcon
        style={{ height: iconSize, width: iconSize, cursor: 'pointer' }}
        alt = 'help'
        onClick={() => {
          setShow(true)
        }}
      />
      <Modal show={show} size="lg" onHide={ () => setShow(false) }>
        <Modal.Header closeButton>
          <Modal.Title>Help</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ReactMarkdown remarkPlugins={[gfm]}>{ markdown }</ReactMarkdown>   
        </Modal.Body>
      </Modal>
    </>
  )
}
